import { useNavigate } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export const statusStyle: Record<Comic["status"], string> = {
  连载中: "bg-secondary-500 text-background-50",
  已完结: "bg-foreground-700 text-background-50",
  新上架: "bg-accent-500 text-background-50",
};

export default function ComicCard({ comic }: { comic: Comic }) {
  const navigate = useNavigate();

  return (
    <article
      onClick={() => navigate(`/comic/${comic.id}`)}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300 hover:shadow-md"
      data-product-shop
    >
      <div className="relative overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} · ${comic.latestChapter}`}
          className="aspect-[4/5] w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2.5 py-1 text-xs font-medium ${statusStyle[comic.status]}`}
        >
          {comic.status}
        </span>
        {comic.isHot && (
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
            <i className="ri-fire-fill"></i> 热门
          </span>
        )}
        {comic.isNew && !comic.isHot && (
          <span className="absolute right-2 top-2 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
            新作
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-700">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {comic.categories.slice(0, 2).join(" / ")} · {comic.totalChapters}
        </p>
        <div className="mt-2 flex items-center justify-between border-t border-background-100 pt-2 text-xs">
          <span className="flex items-center gap-1 font-medium text-accent-600">
            <i className="ri-star-fill"></i> {comic.rating.toFixed(1)}
          </span>
          <span className="flex items-center gap-1 text-foreground-500">
            <i className="ri-eye-line"></i> {comic.views}
          </span>
        </div>
      </div>
    </article>
  );
}